import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { membershipCopy } from '../../data/membership';
import { MembershipPlans } from './MembershipPlans';
import { MembershipBenefits } from './MembershipBenefits';
import { MembershipJoin } from './MembershipJoin';
import { MembershipFAQ } from './MembershipFAQ';
export function Membership() {
  const {
    lang
  } = useLanguage();
  const copy = membershipCopy[lang];
  return <section id="membership" className="bg-mist py-20 sm:py-24" data-id="element-256" data-mp="3sqgtxtoiwklf">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-257" data-mp="1jw8cph8m4vs">
        <div className="grid gap-6 lg:grid-cols-[1.1fr_1fr] lg:items-end lg:gap-16" data-id="element-258" data-mp="1midyjkkiabd">
          <div data-id="element-259" data-mp="5k6cdwlgyl80">
            <p className="text-sm font-semibold text-brand-blue" data-id="element-260" data-mp="aldlbyzclqg9">{copy.kicker}</p>
            <h2 className="mt-2 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-261" data-mp="aj9ilkd6qxhk">
              {copy.title}
            </h2>
            <p className="mt-3 text-lg font-medium leading-relaxed text-navy/80" data-id="element-262" data-mp="2cds4t2hjj2ys">
              {copy.subtitle}
            </p>
          </div>
          <p className="text-base leading-relaxed text-ink/70" data-id="element-263" data-mp="1cl8m7w8nfh5d">{copy.description}</p>
        </div>

        <MembershipPlans plans={copy.plans} perWash={copy.perWash} data-id="element-264" data-mp="17qulrff4qjtu" />
        <MembershipBenefits title={copy.benefitsTitle} benefits={copy.benefits} data-id="element-265" data-mp="13rlr88c9mhx8" />
        <MembershipJoin copy={copy} data-id="element-266" data-mp="yt2444lxr03a" />
        <MembershipFAQ title={copy.faqTitle} items={copy.faq} data-id="element-267" data-mp="ypwgyuwva8a7" />
      </div>
    </section>;
}